exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.links[data-v-7c8d50f2] {\n  padding-right: 20px;\n  width: 180px;\n  border-right: 1px solid #efefef;\n}\n.links .links-item[data-v-7c8d50f2] {\n    padding: 10px 0;\n    text-align: center;\n    cursor: pointer;\n}\n.links .links-item.active[data-v-7c8d50f2] {\n      background: #ecf5ff;\n      border: 1px solid #b4d9fd;\n      border-radius: 60px;\n      color: #1f82e0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-7c8d50f2","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/theme.scss","/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/_mixin.scss"]}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/template_links/comps/tabs.vue
// module id = 1614
// module chunks = 0